<template>
  <div class="order-tracker">
    <!-- Order Placed Step -->
    <div
      class="order-tracker__step"
      :class="{
        'order-tracker__step--active': status.stage >= 0,
        'order-tracker__step--ready': status.stage >= 2,
      }"
      data-order-placed="placed"
    >
      <span class="order-tracker__icon">
        <font-awesome-icon icon="envelope" class="wc-icon" />
      </span>
      <span class="order-tracker__label">{{ status.stages[0] }}</span>
    </div>

    <!-- Order In Progress Step -->
    <div
      class="order-tracker__step"
      :class="{
        'order-tracker__step--active': status.stage >= 1,
        'order-tracker__step--ready': status.stage >= 2,
      }"
      data-order-progress="progress"
    >
      <span class="order-tracker__icon">
        <font-awesome-icon
          :icon="status.stage != 1 ? 'store' : 'arrows-rotate'"
          class="wc-icon"
          :class="{ 'wc-icon-spin': status.stage === 1 }"
        />
      </span>
      <span class="order-tracker__label">{{ status.stages[1] }}</span>
    </div>

    <!-- Order Ready Step -->
    <div
      class="order-tracker__step"
      :class="{ 'order-tracker__step--ready': status.stage >= 2 }"
      data-order-ready="ready"
    >
      <span class="order-tracker__icon">
        <font-awesome-icon icon="check" class="wc-icon" />
      </span>
      <span class="order-tracker__label">{{ status.stages[2] }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WCOrderTracker',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

@keyframes wc-icon-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.wc-icon-spin {
  -webkit-animation: wc-icon-spin 2s infinite linear;
  animation: wc-icon-spin 2s infinite linear;
}

.order-tracker {
  position: relative;
  background-color: #ddd;
  height: rem(7px);
  display: flex;
  margin-bottom: $margin-3 * 4.375;
  margin-top: $margin-3 * 2.25;
}

.order-tracker__label {
  display: block;
  margin-top: $margin-2;
}

.order-tracker__icon {
  display: inline-block;
  width: rem(40px);
  height: rem(40px);
  position: relative;
  border-radius: 100%;
  background: #ddd;

  .wc-icon {
    margin-top: $margin-3 * 0.75;
  }
}

.order-tracker__step {
  flex-grow: 1;
  width: 25%;
  margin-top: $margin-n3 * 1.125;
  text-align: center;
  position: relative;

  &::before {
    height: rem(7px);
    position: absolute;
    content: '';
    width: 100%;
    left: 0;
    top: rem(18px);
  }

  &--active {
    &::before {
      background: var(--primary, $primary);
    }

    .order-tracker__icon {
      background: var(--primary, $primary);
      color: var(--white);
    }
  }

  &--ready {
    &::before {
      background: var(--success);
    }

    .order-tracker__icon {
      background: var(--success);
      color: var(--white);
    }
  }
}
</style>
